<template>
  <div v-wechat-title="title" style="height:100%">
    {{title}}
  </div>
</template>
<script>
export default {
    name: `TransferTrace`,
    props: {

    },
    data() {
        return {
            title: `转运追踪`
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Transfer/Trace.vue